import { DateObject } from 'react-multi-date-picker';
import { FechaString } from './interfaces';

type Sala = {
  Id: number;
  Nombre: string;
  Descripcion: string;
  Largo: number;
  Ancho: number;
  Foto: string;
  Aforo: number;
  Asientos?: Asiento[];
};

type Horario = {
  Dia: DiasSemana;
  HorarioIni: Date;
  HorarioFin: Date;
};

export enum DiasSemana {
  Lunes = 1,
  Martes = 2,
  Miércoles = 3,
  Jueves = 4,
  Viernes = 5,
  Sábado = 6,
  Domingo = 7,
}

type Taller = {
  Id: number;
  Nombre: string;
  Sala: Sala | null;
  SalaId?: number;
  Docente: string;
  Programa: string;
  ValorCuota: number;
  Dias: number[];
  Horarios: Horario[];
  FechaInicio: Date | string;
  FechaFin: Date | string;
  Afiche: File | string;
  VisibleEnGrilla: boolean;
};

interface TallerBase {
  Id: number;
  Nombre: string;
  NombreSala: string;
  Docente: string;
  Programa: string;
  ValorCuota: number | string;
  AficheUrl: File | string;
  VisibleEnGrilla: boolean | string;
  Dias?: number[] | string[];
  Horarios?: Horario[];
  FechaInicio?: Date | string;
  FechaFin?: Date | string;
  HorarioIni?: string[];
  HorarioFin?: string[];
  DetallePath?: string;
  HorariosClases?: FechaString[];
  Inscriptos?: Usuario[] | string;
}

export type TallerListado = {
  Id: number;
  AficheUrl: File | string;
  Docente: string;
  HorariosClases: FechaString[];
  Nombre: string;
  NombreSala: string;
  Programa: string;
  ValorCuota: number | string;
  VisibleEnGrilla: boolean | string;
};

export interface TallerListadoAlumno {
  Id: number;
  Nombre: string;
  NombreSala: string;
  Docente: string;
  ValorCuota: number | string;
  AficheUrl: File | string;
  Dias?: string[];
  Horarios?: Horario[];
  FechaInicio?: Date | string;
  FechaFin?: Date | string;
  HorarioIni?: string[];
  HorarioFin?: string[];
  DetallePath?: string;
  HorariosClases?: FechaString[];
}

type Alquiler = {
  Id: number;
  NombreInquilino: string;
  Telefono: string;
  Sala: Sala | null;
  SalaId?: number;
  FechaInicio: Date | string;
  FechaFin: Date | string;
  Fecha: FechaString;
  Monto: number;
};

type Fecha = {
  Id?: number;
  FechaInicio: Date;
  FechaFin: Date;
};

type Asiento = {
  Codigo: string;
  Sala: Sala;
};

type Funcion = {
  Id?: number;
  CantAsientosDisponibles: number;
  Duracion: number;
  Fecha: FechaString;
};

type FuncionConDate = Omit<Funcion, 'Fecha'> & {
  Fecha: Fecha;
};

type CompraEntrada = {
  CompraId: number;
  SubTotal: number;
  Descuento: number;
  NombreEspectaculo: string;
  CantAsientosComprados: number;
  FechaHoraInicioDeFuncion: string;
};

type Compra = {
  CompraId: number;
  UsuarioId: number;
  FuncionId?: number;
  CantAsientos: number;
  AdminId?: number;
};

type Cuota = {
  MesAnio: Date;
  Paga: boolean;
  Monto: number;
  Suscripcion: Suscripcion;
};

type Espectaculo = {
  Id: number;
  Nombre: string;
  Descripcion: string;
  Afiche: File | string;
  AficheUrl?: string;
  Banner?: File | string;
  BannerDestacado?: boolean;
  Sala: Sala | null;
  SalaId?: number;
  AforoDisponible: number; // Cantidad de asientos disponibles
  Precio: number;
  Genero: TipoGenerico | null;
  GeneroId?: number;
  Funciones?: Funcion[];
  Duracion?: number;
  Fotos?: File[];
  Elenco: string;
  TipoElencoId?: number;
  TipoElenco?: TipoElenco;
  Autor: string;
  Director: string;
  AsistenteDireccion?: string;
  Vestuarista?: string;
  Iluminador?: string;
  Sonidista?: string;
  Musica?: string;
  DisenoGrafico?: string;
  Fotografia?: string;
  Escenografia?: string;
  Traduccion?: string;
  PorcentajeCofonte: number;
  PorcentajeAgadu: number;
  VisibleEnGrilla: boolean;
  FechasInicio?: DateObject[];
};

export interface ICaratulaEspectaculo {
  Id: number;
  Nombre: string;
  AficheUrl: string;
  BannerUrl: string;
  BannerDestacado: boolean;
  Descripcion: string;
  Director: string;
  Fechas: Fecha[];
  Sala?: string;
  TieneFotos?: boolean;
  VisibleEnGrilla?: boolean;
}
export interface CompraBase {
  Id: number;
  UsuarioId?: number;
  UsuarioNombre?: string;
  FechaInicioFuncion?: string;
  NombreEspectaculo: string;
  CantAsientos: number;
  AdminId?: number;
  Precio?: number | string;
  MontoSinDescuento?: number | string;
  DescuentoAplicado?: number | string;
  Aprobada?: boolean | string;
  FechaCompra?: string;
  Codigo?: string;
}
export interface IFichaEspectaculo {
  Id: number;
  VisibleEnGrilla: boolean;
  Nombre: string;
  Descripcion: string;
  AficheUrl: string;
  Fotos: string[];
  SalaId: number;
  AforoDisponible: number;
  Elenco: string;
  Autor: string;
  Director: string;
  GeneroId: number;
  Precio: number;
  Banner: string;
  AsistenteDireccion: string;
  Vestuarista: string;
  Iluminador: string;
  Sonidista: string;
  Musica: string;
  DisenoGrafico: string;
  Fotografia: string;
  Escenografia: string;
  Traduccion: string;
  PorcentajeAgadu: number;
  PorcentajeCofonte: number;
  TipoElencoId: number;
  Funciones: Funcion[];
}

export interface IRequestEspectaculo {
  Id: number;
  Nombre: string;
  VisibleEnGrilla: boolean;
  AforoDisponible: number;
  TipoElencoId: number;
  PorcentajeAgadu: number;
  PorcentajeCofonte: number;
  Afiche: File | string;
  Banner?: File;
  BannerDestacado?: boolean;
  SalaId?: number;
  Fotos?: FileList | null;
  Autor: string;
  Elenco: string;
  Director: string;
  Precio: number;
  Descripcion: string;
  GeneroId?: number;
  AsistenteDireccion?: string;
  Vestuarista?: string;
  Iluminador?: string;
  Sonidista?: string;
  Musica?: string;
  DisenoGrafico?: string;
  Traduccion?: string;
  Escenografia?: string;
  Fotografia?: string;
}

export type IAltaFunciones = {
  EspectaculoId: number;
  FechasObras?: string[];
  Fechas?: FechaString[];
  Duracion?: number;
};

export type EdicionTipos = {
  Nombre: string;
  Tipos: string[];
};

type Suscripcion = {
  Nombre: string;
  Estado: boolean;
  FechaInicio: Date;
  Tipo: TipoSuscripcion;
  Usuario: Usuario;
  Taller: Taller;
  Cuotas: Cuota[];
};

type Usuario = {
  Id: number;
  Activo?: boolean;
  Confirmado?: boolean;
  Nombre: string;
  Apellido: string;
  Email: string;
  Password: string;
  Rol: TipoGenerico;
  FechaNac: Date | null;
  DescuentoAsignado: number;
  Telefono: string;
  EsElenco: boolean;
  EsAlumno: boolean;
  TipoSocio: TipoGenerico;
  // Los talleres no forman parte de la clase Usuario, pero en el FE sirve tenerlos así
  Talleres?: Taller[];
};

type TipoSuscripcion = {
  Nombre: 'Fundador' | 'Suscriptor' | 'Alumno';
};

type UsuarioBase = Omit<
  Usuario,
  | 'Apellido'
  | 'Talleres'
  | 'FechaNac'
  | 'TipoSocioId'
  | 'TipoSocio'
  | 'TipoRol'
  | 'EsElenco'
  | 'EsAlumno'
  | 'RolId'
  | 'DescuentoAsignado'
  | 'Activo'
  | 'Confirmado'
> & {
  Id: number;
  Apellido?: string;
  EsElenco: string;
  EsAlumno: string;
  TipoSocio: string;
  FechaNac: string | null;
  Rol: string;
  DescuentoAsignado: number | string;
  DetallePath?: string;
  Activo?: string;
  Confirmado?: string;
};

export type UsuarioAlumno = {
  Id: number;
  Nombre?: string;
  Apellido?: string;
  EsElenco: string;
  TipoSocio: string;
  FechaNac: string | null;
  Rol: string;
  DescuentoAsignado: number | string;
  DetallePath?: string;
  Activo?: string;
  Confirmado?: string;
  Email: string;
  Telefono: string;
};

export type UsuarioDTO = Omit<Usuario, 'TipoSocio' | 'Rol'> & {
  Id: number;
  TipoSocio: string;
  Rol: string;
};

type AlquilerBase = Omit<Alquiler, 'Sala' | 'Telefono' | 'Monto' | 'Fecha' | 'FechaInicio' | 'FechaFin'> & {
  SalaId?: number;
  NombreSala?: string;
  Fecha?: Fecha;
  FechaInicio?: string;
  FechaFin?: string;
  Telefono?: string;
  Monto: number | string;
  NombreInquilino: string;
};

interface EspectaculoBase {
  Id: number;
  Nombre: string;
  Director: string;
  AficheUrl?: string;
  BannerUrl: string;
  BannerDestacado: string;
  Sala?: string;
  Fotos?: string[];
  Fechas?: FechaString[];
  Temporada?: string;
  FechaInicio?: string;
  FechaFin?: string;
  Precio?: number | string;
  VisibleEnGrilla?: string;
  Descripcion?: string;
  DetallePath?: string;
}
export interface EspectaculoBanner {
  Id: number;
  Nombre: string;
  Director: string;
  BannerUrl?: string;
  FechaInicio: Date;
  FechaFin: Date;
  Descripcion?: string;
}

export interface Boletin {
  Id: number;
  NombreEnviador: string;
  Asunto: string;
  Titulo: string;
  Body: string;
  ImagenUrl: string;
  FechaEnviado: string;
}

export type EspectaculoGrilla = {
  Id: number;
  AficheUrl: string;
  Fechas: FechaString[];
  Nombre: string;
};

export interface TipoElenco extends TipoGenerico {
  MontoFijoSala: number;
  PorcentajeGananciaTeatro: number;
}

export type TipoGenericoRequest = {
  Nombre: string;
};

export type VentaListado = {
  Id: number;
  NombreEspectaculo: string;
  FechaInicioTemporada: string;
  FechaFinTemporada: string;
  CantEntradasVendidas: number;
  MontoTotalVentaEntradas: number | string;
  MontoTotalGananciaEntradas: number | string; // del teatro para esa temporada de ese espectáculo
};

export type TipoGenerico = {
  Id: number;
  Nombre: string;
};
export interface TipoParametro extends TipoGenerico {
  Valor: number;
}

export interface RequestParametro {
  Id: number;
  Concepto: string;
  Valor: number;
}

export type {
  Sala,
  Taller,
  Horario,
  Alquiler,
  Fecha,
  Asiento,
  Funcion,
  CompraEntrada,
  Cuota,
  Espectaculo,
  Suscripcion,
  Usuario,
  TipoSuscripcion,
  UsuarioBase,
  AlquilerBase,
  EspectaculoBase,
  TallerBase,
  Compra,
  FuncionConDate,
};
